import React from 'react';
import * as styles from './contactSocials.module.scss';
import { SocialLinks } from '../SocialLinks/SocialLinks';
import { useSiteQuery } from '../../hooks';

 const ContactSocials = () => {
  const {footerSocialIcons} = useSiteQuery()
  return(
  <div className={styles.contactSocials}>
    <SocialLinks socials={footerSocialIcons} />
  </div>
  )
  };
  export default ContactSocials